import React from 'react';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';
import './About.css';

const About = () => {
  const { t } = useTranslation();
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  return (
    <section id="about" className="section about">
      <div className="container">
        <h2 className="section-title" data-aos="fade-up">{t('about.title')}</h2>
        
        <div ref={ref} className={`about-content ${inView ? 'fade-in' : ''}`}>
          <div className="about-text">
            <p>{t('about.description1')}</p>
            <p>{t('about.description2')}</p>
            
            <div className="about-info">
              <div className="info-item">
                <strong>{t('about.name')}</strong>
                <span>Mariano Ventura</span>
              </div>
              <div className="info-item">
                <strong>{t('about.email')}</strong>
                <a href="mailto:marianovc251@gmail.com">marianovc251@gmail.com</a>
              </div>
            </div>
          </div>
          
          {/* <div className="about-stats">
            <div className="stat">
              <h3>3+</h3>
              <p>{t('about.projects')}</p>
            </div>
            <div className="stat">
              <h3>2+</h3>
              <p>{t('about.experience')}</p>
            </div>
            <div className="stat">
              <h3>5+</h3>
              <p>{t('about.clients')}</p>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default About;